const prefixCls = 'web.tools.';

export const localesTools = {
  // 工具箱通用
  [prefixCls + 'toolbox']: {
    zh_CN: '智能工具箱',
    en_GB: 'Smart Toolbox',
  },
  [prefixCls + 'pricing']: {
    zh_CN: '定价计算器',
    en_GB: 'Pricing Calculator',
  },

  // 定价计算器
  [prefixCls + 'pricing.selectCountry']: {
    zh_CN: '选择国家',
    en_GB: 'Select Country',
  },
  [prefixCls + 'pricing.baseCost']: {
    zh_CN: '输入基础成本',
    en_GB: 'Enter Base Cost',
  },
  [prefixCls + 'pricing.productCost']: {
    zh_CN: '进货价 / 产品成本',
    en_GB: 'Product Cost',
  },
  [prefixCls + 'pricing.shippingCost']: {
    zh_CN: '头程运输成本（按件摊）',
    en_GB: 'First-Mile Shipping Cost (per item)',
  },
  [prefixCls + 'pricing.fbnFee']: {
    zh_CN: 'NOON FBN 配送费（每单）',
    en_GB: 'NOON FBN Delivery Fee (per order)',
  },
  [prefixCls + 'pricing.estimator']: {
    zh_CN: 'FBN 配送费小助手',
    en_GB: 'FBN Shipping Estimator',
  },
  [prefixCls + 'pricing.weight']: {
    zh_CN: '重量 (Kg)',
    en_GB: 'Weight (Kg)',
  },
  [prefixCls + 'pricing.estimateAndFill']: {
    zh_CN: '自动估算配送费并填入上方',
    en_GB: 'Estimate and Fill Above',
  },
  [prefixCls + 'pricing.selectCategory']: {
    zh_CN: '选择类目 / 佣金',
    en_GB: 'Select Category / Commission',
  },
  [prefixCls + 'pricing.category']: {
    zh_CN: '类目（简化平均佣金）',
    en_GB: 'Category (Simplified Avg. Commission)',
  },
  [prefixCls + 'pricing.commissionRate']: {
    zh_CN: 'NOON 类目佣金（%）',
    en_GB: 'NOON Category Commission (%)',
  },
  [prefixCls + 'pricing.targetProfitRate']: {
    zh_CN: '目标利润率（%）',
    en_GB: 'Target Profit Rate (%)',
  },
  [prefixCls + 'pricing.result']: {
    zh_CN: '计算结果',
    en_GB: 'Calculation Result',
  },
  [prefixCls + 'pricing.suggestedPrice']: {
    zh_CN: '建议售价',
    en_GB: 'Suggested Price',
  },
  [prefixCls + 'pricing.costBreakdown']: {
    zh_CN: '成本构成',
    en_GB: 'Cost Breakdown',
  },
  [prefixCls + 'pricing.totalCost']: {
    zh_CN: '总成本',
    en_GB: 'Total Cost',
  },
  [prefixCls + 'pricing.estimatedProfit']: {
    zh_CN: '预计利润',
    en_GB: 'Estimated Profit',
  },
  [prefixCls + 'pricing.actualProfitRate']: {
    zh_CN: '实际利润率',
    en_GB: 'Actual Profit Rate',
  },
  [prefixCls + 'pricing.platformCommission']: {
    zh_CN: '平台佣金',
    en_GB: 'Platform Commission',
  },
};
